<template lang="html">
  <div class="selectable-list">
    <SymbiumSelectableOption
      v-for="option in collection" :key="option.text"
      :option="option"
      @toggle-option="() => toggleOption(option)"
      klass="gap-8"
    />
    <div class="gap-1x"></div>
  </div>
</template>

<script>
import SymbiumSelectableOption from './SymbiumSelectableOption.vue'
export default {
  props: ["options"],
  components: { SymbiumSelectableOption },
  methods: {
    toggleOption(option) {
      option.selected = !option.selected
      this.$emit('update-option', option)
    }
  },
  data() {
    return {
      collection: this.options
    }
  }
}
</script>

<style lang="scss">
.selectable-list {
  .option-text {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.002em;
  }
}
</style>
